export enum EndpointTypes {
    led,
    pw,
    blinker
}